import React from 'react';
import styled from 'styled-components';

const VisitButton = (props) => {
    const StyledBtn = styled.button`
        position: relative;
        width: 50%;
        padding: 16px 24px;
        margin: 24px auto;
        font-family: Roboto, sans-serif;
        font-weight: 500;
        font-size: 16px;
        color: white;
        background-color: #172121; 
        border: none;
        border-radius: 9999px;    
        outline: none;
        overflow: hidden;
        filter: drop-shadow(0 2px 8px rgba(${props.color}, 0.32));
        transition: 0.3s cubic-bezier(0.215, 0.61, 0.355, 1); 
        &:hover {
            span {
                transform: translateY(-55px);
            }
        }
        @media (max-width: 43em) {
            width: 70%;           
        }
    `

    const StyledText = styled.span`
        display: inline-flex;
        vertical-align: middle;
        font-weight: 600;
        transition: 0.3s cubic-bezier(0.215, 0.61, 0.355, 1);
        transition-delay: 0.05s;
    `

    const StyledSocialIcons = styled.ul`
        position: absolute;
        top: 50%;
        left: 15%;
        right: 15%;
        display: flex;
        margin: 0;
        padding: 0;
        list-style-type: none;
        transform: translateY(-50%);
        li {
        flex: 1;

        a {
            display: inline-flex;
            vertical-align: middle;
            transform: translateY(55px);
            transition: 0.3s cubic-bezier(0.215, 0.61, 0.355, 1);

            &:hover {
            opacity: 0.5;
            }
        }
        }
        &:hover{
            li {
                a {
                    transform: translateY(0);
                }
            }
        }
    `

    return (
        <StyledBtn>
            <StyledText>Visit this Project</StyledText>
            <StyledSocialIcons>
                <li>
                    <a href={props.ghLink} target="_blank" rel="noreferrer" aria-label="Redirect to the live demo of this project">
                        <svg
                            viewBox="0 0 1024 1024"
                            width="20"
                            height="20"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            >
                            <path
                                d="M950.930286 512q0 143.433143-83.748571 257.974857t-216.283429 158.573714q-15.433143 2.852571-22.601143-4.022857t-7.168-17.115429l0-120.539429q0-55.442286-29.696-81.115429 32.548571-3.437714 58.587429-10.313143t53.686857-22.308571 46.299429-38.034286 30.281143-59.977143 11.702857-86.016q0-69.12-45.129143-117.686857 21.138286-52.004571-4.534857-116.589714-16.018286-5.12-46.299429 6.290286t-52.589714 25.161143l-21.723429 13.677714q-53.174857-14.848-109.714286-14.848t-109.714286 14.848q-9.142857-6.290286-24.283429-15.433143t-47.689143-22.016-49.152-7.68q-25.161143 64.585143-4.022857 116.589714-45.129143 48.566857-45.129143 117.686857 0 48.566857 11.702857 85.723429t29.988571 59.977143 46.006857 38.253714 53.686857 22.308571 58.587429 10.313143q-22.820571 20.553143-28.013714 58.88-11.995429 5.705143-25.746286 8.557714t-32.548571 2.852571-37.449143-12.288-31.744-35.693714q-10.825143-18.285714-27.721143-29.696t-28.306286-13.677714l-11.410286-1.682286q-11.995429 0-16.603429 2.56t-2.852571 6.582857 5.12 7.972571 7.460571 6.875429l4.022857 2.852571q12.580571 5.705143 24.868571 21.723429t17.993143 29.110857l5.705143 13.165714q7.460571 21.723429 25.161143 35.108571t38.253714 17.115429 39.716571 4.022857 31.744-1.974857l13.165714-2.267429q0 21.723429 0.292571 50.834286t0.292571 30.866286q0 10.313143-7.460571 17.115429t-22.820571 4.022857q-132.534857-44.032-216.283429-158.573714t-83.748571-257.974857q0-119.442286 58.88-220.306286t159.744-159.744 220.306286-58.88 220.306286 58.88 159.744 159.744 58.88 220.306286z"
                                p-id="2760"
                                fill="white"
                            ></path>
                        </svg>
                    </a>
                </li>
                <li>
                    <a href={props.demoLink} target="_blank" rel="noreferrer" aria-label="Redirect to the GitHub repository of this project">
                        <svg 
                            viewBox="0 0 1024 1024" 
                            width="20" 
                            height="20" 
                            version="1.1" 
                            xmlns="http://www.w3.org/2000/svg"
                            >
                            <path 
                                d="M496 0c-273.952 0-496 222.048-496 496s222.048 496 496 496 496-222.048 496-496-222.048-496-496-496zM927.2 480h-191.872c-1.76-70.88-14.368-138.592-36.736-200.576 43.2-18.016 83.136-41.984 119.552-70.304 64.736 72.672 105.216 167.040 109.056 270.88zM478.304 927.104c-53.184-44.288-97.792-101.792-130.432-168.576 41.888-13.088 86.272-20.256 132.128-21.728v190.368c-0.576 0-1.12-0.032-1.696-0.064zM513.632 64.896c60.352 50.24 109.6 117.536 142.912 196.032-45.632 15.584-94.112 24.64-144.576 26.24v-222.368c0.608 0.032 1.12 0.064 1.664 0.096zM566.944 70.336c88.32 14.688 167.552 55.936 229.248 115.648-33.504 25.696-70.112 47.456-109.696 63.936-29.12-69.024-69.984-130.048-119.552-179.584zM480 64.8v222.368c-50.464-1.632-98.976-10.656-144.576-26.24 33.312-78.496 82.56-145.792 142.912-196.032 0.576-0.032 1.088-0.064 1.664-0.096zM305.472 249.952c-39.52-16.48-76.16-38.24-109.664-63.936 61.664-59.712 140.928-100.96 229.248-115.648-49.6 49.504-90.432 110.528-119.584 179.584zM323.36 290.432c49.344 17.12 101.92 27.104 156.64 28.768v160.8h-191.328c1.728-67.008 13.6-131.040 34.688-189.568zM480 512v192.8c-50.464 1.536-99.264 9.792-145.248 24.608-27.712-65.984-44.064-139.488-46.080-217.408h191.328zM425.056 921.664c-79.136-13.152-151.008-47.616-209.44-97.664 31.52-21.856 65.6-40.352 102.016-54.4 27.904 57.856 64.416 109.216 107.424 152.064zM512 927.2v-190.368c45.824 1.472 90.24 8.64 132.128 21.728-32.672 66.784-77.248 124.288-130.432 168.576-0.544 0-1.12 0.032-1.696 0.064zM674.368 769.6c36.384 14.048 70.432 32.576 102.016 54.4-58.432 50.016-130.304 84.512-209.44 97.664 43.008-42.848 79.488-94.208 107.424-152.064zM657.248 729.408c-46.016-14.816-94.816-23.072-145.248-24.608v-192.8h191.328c-2.016 77.92-18.4 151.424-46.080 217.408zM512 480v-160.8c54.688-1.664 107.264-11.616 156.64-28.736 21.056 58.528 32.928 122.56 34.688 189.568h-191.328zM173.888 209.12c36.416 28.32 76.352 52.288 119.52 70.304-22.368 61.984-34.976 129.696-36.736 200.576h-191.872c3.84-103.84 44.32-198.208 109.088-270.88zM64.8 512h191.872c1.984 81.76 19.072 158.976 48.096 228.384-40.544 15.808-78.336 36.864-113.216 61.792-75.136-74.784-122.56-177.024-126.752-290.176zM800.448 802.144c-34.88-24.896-72.672-45.984-113.248-61.792 29.056-69.408 46.112-146.624 48.128-228.384h191.872c-4.192 113.184-51.648 215.424-126.752 290.176z"
                                fill="white"
                            ></path>
                        </svg>
                    </a>
                </li>
            </StyledSocialIcons>
        </StyledBtn>
    )
};

export default VisitButton;